export const menuitems = [
    {
        title: 'Use Cases',
        path: '#useCase',
        sub_menu: [

        ]

    },
    {
        title: 'Pricing',
        path: '#contactsales',
        sub_menu: [

        ]

    },
    {
        title: 'About Us',
        sub_menu: [],

    },
    {
        title: 'Book A Demo',
        sub_menu: [

        ]

    },
]